import CommunityNavigationWidgetGroupModel from '../group';
import CommunityNavigationWidgetItemModel from '../item';
import { CommunityNavigationWidgetLinkModel } from '../link';

interface EscapingArea {
    start: number
    end: number    
}

interface TempEscapingArea {
    start: number
    end?: number
    l: number
    r: number
}

export default class CommunityNavigationWidgetGroupsBuilder {
    static instance = new CommunityNavigationWidgetGroupsBuilder();

    constructor() { }

    build(links: Array<CommunityNavigationWidgetLinkModel>) {
        return links
            .map(link => this.process(link))
            .reduce((items, item) => {
                const prev = _(items).last();

                if (prev != undefined && prev.canMergeWith(item))
                    prev.mergeWith(item);
                else
                    items.push(item);

                return items;
            }, new Array<CommunityNavigationWidgetItemModel>());
    }

    private process(link: CommunityNavigationWidgetLinkModel): CommunityNavigationWidgetItemModel {
        let newLink: CommunityNavigationWidgetLinkModel;

        const title = link.title();
        const parts = this.splitTitle(title).map(part => this.cleanUpTitlePart(part));

        if (parts.length > 1) {
            const groups = _(parts).initial();
            const name = <string>_(parts).last();

            newLink = link.clone<CommunityNavigationWidgetLinkModel>({
                title: name,
                css: ''
            });

            const group = <CommunityNavigationWidgetGroupModel>_(groups).reduceRight((result, name) => {
                const group = new CommunityNavigationWidgetGroupModel({
                    title: name,
                    css: link.css()
                });

                if (result != undefined)
                    group.add(result);
                else
                    group.add(newLink);

                return group;
            }, <CommunityNavigationWidgetGroupModel | undefined>undefined);

            group.isRoot(true);

            return group;
        } else if (parts.length === 1) {
            newLink = link.clone<CommunityNavigationWidgetLinkModel>({
                title: parts[0],
                toDoCount: link.toDoCount
            });
        } else {
            newLink = link.clone<CommunityNavigationWidgetLinkModel>();
        }

        newLink.isRoot(true);

        return newLink;
    }

    private splitTitle(title: string) {
        const escapingAreas = this.getEscapingAreas(title);
        const splitIndexes = this.getIndexesOf(title, '/').filter(idx => !escapingAreas.some(area => idx > area.start && idx < area.end));

        if (splitIndexes.length === 0) {
            return [title];
        } else {
            return _(splitIndexes.concat([title.length])).map(function (index, idx, list) {
                var prev = list[idx - 1];

                var startIdx,
                    endIdx;

                if (prev === undefined) {
                    startIdx = 0;
                    endIdx = index;
                } else {
                    startIdx = prev + 1;
                    endIdx = index;
                }

                return title.substring(startIdx, endIdx);
            });
        }
    }

    private getEscapingAreas(str: string) {
        const areas = [...str].reduce((list, s, idx) => {
            let area = _(list).last();

            switch (s) {
                case '[':
                    if (area == undefined || area.end != undefined) {
                        area = { start: idx, l: 1, r: 0 };
                        list.push(area);
                    } else {
                        area.l++;
                    }

                    break;
                case ']':
                    if (area !== undefined) {
                        area.r++;

                        if (area.r == area.l)
                            area.end = idx;
                    }

                    break;
            }

            return list;
        }, new Array<TempEscapingArea>());

        return areas
            .filter(area => area.end != undefined)
            .map(area => (<EscapingArea>{ start: area.start, end: area.end }));
    }

    private getIndexesOf(str: string, symbol: string) {
        return [...str].reduce((list, s, idx) => {
            if (s == symbol)
                list.push(idx);

            return list;
        }, new Array<number>());
    }

    private cleanUpTitlePart(str: string) {
        return this.getEscapingAreas(str).reduce((str, area, idx) => {
            var result = '',
                offset = -idx * 2,
                start = area.start + offset,
                end = area.end + offset;

            if (start > 0)
                result += str.substring(0, start);

            result += str.substring(start + 1, end);

            if (end < str.length - 1)
                result += str.substring(end + 1);

            return result;
        }, str);
    }
}